var Handlebars = require('/app/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "        <cat-devtools id=\"devtools\"></cat-devtools>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <script>\n            var ENV = "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"ENV") || (depth0 != null ? lookupProperty(depth0,"ENV") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ENV","hash":{},"data":data,"loc":{"start":{"line":16,"column":22},"end":{"line":16,"column":31}}}) : helper))) != null ? stack1 : "")
    + ";\n        </script>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<!DOCTYPE html>\n<html id=\"hermes_body\">\n<head>\n    <meta name=\"google-site-verification\" content=\"wgsXZSPJ43_BilgDAXs1hhniB--4cwFS4rWRK7Z07Zs\" />\n</head>\n<body>\n    <script src=\"https://maps.api.2gis.ru/2.0/loader.js?pkg=full\"></script>\n    <cat-layout id=\"layout\" class=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1), depth0))
    + "\"></cat-layout>\n\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"isRelease") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":4},"end":{"line":12,"column":15}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"ENV") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":18,"column":11}}})) != null ? stack1 : "")
    + "\n    <script src=\"/public/bundle.js\"></script>\n\n    <!-- Jivo Live Chat -->\n    <script src=\"//code.jivo.ru/widget/FdVw9XPMTL\" async></script>\n    <!-- /Jivo Live Chat -->\n</body>\n</html>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./components/layout/document/template.hbs
// module id = 979
// module chunks = 0